import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AIManyCallAnalysis } from "../../../interfaces/db";

export interface AIManyCallAnalysisState {
  data: { [k: string]: {
    data: AIManyCallAnalysis[],
    loaded: boolean,
    isLoading: boolean,
    error: string | null
  } };
}
const aiAnalysisInitialState: AIManyCallAnalysisState = {
  data: {},
};

const ensureUserState = (state: AIManyCallAnalysisState, user_id: string) => {
  if (!state.data[user_id]) {
    state.data[user_id] = {
      data: [],
      loaded: false,
      isLoading: false,
      error: null
    };
  }
};

export const aiAnalysisSlice = createSlice({
  name: 'aiAnalysis',
  initialState: aiAnalysisInitialState,
  reducers: {
    updateAILoading: (state, action: PayloadAction<{ user_id: string, isLoading: boolean }>) => {
      ensureUserState(state, action.payload.user_id);
      state.data[action.payload.user_id].isLoading = action.payload.isLoading;
    },
    updateAILoaded: (state, action: PayloadAction<{ user_id: string, loaded: boolean }>) => {
      ensureUserState(state, action.payload.user_id);
      state.data[action.payload.user_id].loaded = action.payload.loaded;
    },
    updateAIData: (state, action: PayloadAction<{ user_id: string, data: AIManyCallAnalysis[] }>) => {
      ensureUserState(state, action.payload.user_id);
      state.data[action.payload.user_id].data = action.payload.data;
    },
    updateBulkAILoading: (state, action: PayloadAction<{ user_ids: string[], isLoading: boolean }>) => {
      action.payload.user_ids.forEach((user_id) => {
        ensureUserState(state, user_id);
        state.data[user_id].isLoading = action.payload.isLoading;
      });
    },
    updateBulkAILoaded: (state, action: PayloadAction<{ user_ids: string[], loaded: boolean }>) => {
      action.payload.user_ids.forEach((user_id) => {
        ensureUserState(state, user_id);
        state.data[user_id].loaded = action.payload.loaded;
      });
    },
    updateBulkAIData: (state, action: PayloadAction<{ user_ids: string[], data: AIManyCallAnalysis[] }>) => {
      action.payload.user_ids.forEach((user_id) => {
        ensureUserState(state, user_id);
        state.data[user_id].data = action.payload.data.filter((analysis) => analysis.user_id === user_id)
      });
    },
  }
})

export const { updateAILoading, updateBulkAILoading, updateBulkAIData, updateAIData, updateAILoaded, updateBulkAILoaded } = aiAnalysisSlice.actions;
